if (Symbol) {
  Array.from([NodeList, HTMLCollection, FileList]).forEach((F) => {
    if (F.prototype[Symbol.iterator]) return
    F.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator]
  })
}

if (NodeList.prototype.forEach === undefined) {
  NodeList.prototype.forEach = Array.prototype.forEach
}